import axiosClient from './axiosClient';

export const getAvailablePacks = (companyId, adminId) => {
    var url =`/company-email-pack/${companyId}/available-packs?adminId=${adminId}`;
    return axiosClient.get(url, {timeout: 20000});
}